import { CheckIcon } from "lucide-react";

import style from "./Steps.module.css";

const Step = ({ step, isActive, isCompleted, index }) => (
  <li className={`${style.step} ${isActive ? style.stepActive : ""}`}>
    {isCompleted ? (
      <div className={style.stepNumberCompleted}>
        <CheckIcon style={{ width: "16px", height: "16px", color: "white" }} />
      </div>
    ) : (
      <div
        className={`${style.stepNumber} ${
          isActive ? style.stepNumberActive : ""
        }`}
      >
        {index}
      </div>
    )}
    <p className={style.stepName}>{step}</p>
  </li>
);

export const Steps = ({ steps, activeStep }) => (
  <ul
    className={style.stepsWrapper}
    style={{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }}
  >
    {steps.map((step, i) => (
      <Step
        key={step}
        step={step}
        isActive={activeStep === i + 1}
        isCompleted={activeStep > i + 1}
        index={i + 1}
      />
    ))}
  </ul>
);
